import React, { useState, FormEvent } from 'react';
import { useAuth } from '../../../contexts/AuthContext';
import './Login.css';

const Login: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  
  const { login, isLoading } = useAuth();

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    
    if (!email || !password) {
      setError('Inserisci email e password');
      return;
    }

    setIsSubmitting(true);
    setError('');

    try {
      const success = await login(email, password);
      
      if (!success) {
        setError('Credenziali non valide. Riprova.');
      }
      // Se il login ha successo, l'utente verrà reindirizzato automaticamente
    } catch (error) {
      console.error('Errore durante il login:', error);
      setError('Errore di connessione. Riprova più tardi.');
    } finally {
      setIsSubmitting(false);
    }
  };


  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <h1>MR Gestionale</h1>
          <p>Accedi al sistema</p>
        </div>

        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label htmlFor="email">Email:</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Inserisci la tua email"
              required
              disabled={isSubmitting || isLoading}
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Password:</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Inserisci la tua password"
              required
              disabled={isSubmitting || isLoading}
            />
          </div>

          {error && (
            <div className="error-message">
              {error}
            </div>
          )}

          <button
            type="submit"
            className="login-button"
            disabled={isSubmitting || isLoading}
          >
            {isSubmitting ? 'Accesso in corso...' : 'Accedi'}
          </button>

        </form>

        <div className="login-footer">
          <p>© 2025 MR Gestionale V2</p>
        </div>
      </div>
    </div>
  );
};

export default Login;